const require200Status = (response) => response.status === 200;
export {
  require200Status
};
